import controller from './form.controller';
import template from './form.html';
import './form.scss';

export default {
	template,
	controller,
	controllerAs:   '$ctrl',
	path:           '/form/:formId?/:options*?',
	reloadOnSearch: false,
};
